export const MOBILE = 'mobile';
export const TABLET = 'tablet';
export const DESKTOP = 'desktop';

export default { MOBILE, TABLET, DESKTOP };
